import { Fieldset, Tabs } from '@chakra-ui/react'

import UserForm from './components/userForm'

import AccountsList from '@app/pages/settings/user/components/accountsList'
import { PageStack } from '@app/shared/layout'

export const Edit = () => (
  <PageStack>
    <Tabs.Root defaultValue="general">
      <Tabs.List>
        <Tabs.Trigger value="general">General</Tabs.Trigger>
        <Tabs.Trigger value="accounts">Manage accounts</Tabs.Trigger>
      </Tabs.List>
      <Tabs.Content value="general">
        <Fieldset.Root
          borderWidth={1}
          borderStyle="solid"
          borderColor="border.default"
          borderRadius="md"
          px={6}
          p={6}
          bg="bg"
        >
          <Fieldset.Content>
            <UserForm />
          </Fieldset.Content>
        </Fieldset.Root>
      </Tabs.Content>
      <Tabs.Content value="accounts">
        <Fieldset.Root
          borderWidth={1}
          borderStyle="solid"
          borderColor="border.default"
          borderRadius="md"
          px={6}
          p={6}
          bg="bg"
        >
          <Fieldset.Content>
            <AccountsList />
          </Fieldset.Content>
        </Fieldset.Root>
      </Tabs.Content>
    </Tabs.Root>
  </PageStack>
)

export default Edit
